import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        container: {
            display: 'flex',
            alignItems: 'stretch',
            gap: 10,
        },
        child: {
            flex: 1,
        },
    }
})

export default useStyles
